// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.safematrix",
    name: "Safematrix",
    homepage: "https://safematrix.io/",
    image_id: "48ea5de9-869a-4994-2402-97afba060900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/sg/app/safematrix/id1613333481",
        android: "https://download.safematrix.io/abm/safematrix.apk",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://safematrix.io/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map